<div *ngIf="viewModel$ | async as viewModel">
  <div class="modal-header">
    <button type="button" class="close close-lg pull-right" aria-label="Close"
            (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h1 class="modal-title">Adaptive Rules

      <img *ngIf="viewModel.loading || deleteLoading" src="/img/loading.gif"
         style="width: 30px; padding-left: 2px; margin-top: -3px; margin-left: 2px;"
         alt="Loading..."/>
    </h1>
  </div>

  <div class="modal-body row adaptive-rules-mapper">
    <div class="col-md-12 clearfloat" style="width:99%; padding-bottom: 12px; min-height: 300px">

          <div class="form-horizontal form-top">
            <rule-controls [loading]="viewModel.loading"
                           (ruleChanged)="updateRule($event, viewModel.userRules)"
                           (selectRuleChanged)="selectRule($event, selectedUserId)"
                           (addedNew)="isNew($event)"
                           [userRules]="userRules$ | async"
                           [selectedUserId]="selectedUserId"
            ></rule-controls>
          </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="pull-right">

      <button class="btn btn-primary btn-save"
              (click)="saveRule()"
              [disabled]="viewModel.loading || !isUpdated">
        Save Rule
      </button>

      <button class="btn btn-primary btn-save"
              (click)="deleteRule(selectedUserId)"
              [disabled]="isNewRule || selectedRule === undefined || deleteLoading">
        Delete Rule
      </button>

      <button class="btn btn-default btn-cancel"
              (click)="onCancel()"
              [disabled]="viewModel.loading">
        Cancel
      </button>
    </div>
  </div>
</div>